import { Flex, Text, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

interface IInputLabel {
  info?: string;
  label: string;
  required?: boolean;
  light?: boolean;
}

const InputLabel = ({
  info,
  label,
  required,
  light
}: IInputLabel) => (
  <Flex align={'center'} mb={4}>
    <Text size={'sm'} mb={4} mr={4} fw={500} c={light ? 'white' : undefined}>{label}</Text>
    {required ? <Text c={'red'} mr={4}>*</Text> : undefined}
    {
      info ?
        <Tooltip label={info}>
          <IconInfoCircle color='gray' size={18} />
        </Tooltip>
        : undefined
    }
  </Flex >
)

export default InputLabel;